(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/section-list-image/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/section-list-image/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let formatImages;
let getCallToAction;

async function renderComponent(model, widgetInfo, position, req, res) {
  var _model$contentType;
  let hbsCompiled;
  let format;
  let isAdmin;
  let features;
  let getLogger;
  let sportProducts;
  let bannerAccessibilityHelpers;
  if (svs.isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    getLogger = trinidad.logger;
    hbsCompiled = hbs.cache['components-banner_layouts-section_list_image-index'];
    formatImages = trinidad.components.require('banner_common', 'banner-helpers').images.formatImages;
    getCallToAction = trinidad.components.require('banner_common', 'banner-helpers').getCallToAction;
    format = trinidad.components.require('utils', 'format').api;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    features = res.locals.features;
    sportProducts = trinidad.components.require('lb-utils', 'sport-products').api;
    bannerAccessibilityHelpers = trinidad.components.require('banner_common', 'banner-helpers').accessibilityHelpers;
  } else {
    var _svs;
    getLogger = svs.core.log.getLogger;
    hbsCompiled = svs.banner_layouts.section_list_image.templates.index;
    formatImages = svs.banner_common.banner_helpers.formatImages;
    getCallToAction = svs.banner_common.banner_helpers.getCallToAction;
    format = svs.utils.format;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    features = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.features;
    sportProducts = svs.components.lbUtils.sportProducts;
    bannerAccessibilityHelpers = svs.banner_common.banner_helpers.accessibilityHelpers;
  }

  const logger = getLogger('banner_layouts:section-list-image');
  const {
    id: bannerId,
    images: modelImages,
    layoutConfig,
    layoutType,
    title,
    targetOffer
  } = model;
  const {
    cube = null,
    slim = false,
    tab = null
  } = layoutConfig || {};
  const images = (modelImages === null || modelImages === void 0 ? void 0 : modelImages.length) && formatImages(model, 'typeName');
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  const crm = targetOffer || '';
  const isFullWidth = true;
  const trackingStringTitle = format.safeString(title) || title;
  const actionViewConfig = {
    inverted: false,
    transparent: false,
    block: false
  };
  const callToActions = [...(model.callToActions || [])].map(action => {
    const callToAction = getCallToAction(action, actionViewConfig);
    return action.actionType ? callToAction : null;
  }).filter(Boolean);
  const trackingString = "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(layoutType, "/").concat(trackingStringTitle);
  const resolveCube = () => {
    const productId = cube !== null ? Number(cube) : '';
    if (!productId) {
      return {
        productId: '',
        productName: ''
      };
    }
    let productName;
    switch (productId) {
      case 11111:
        productName = 'generic';
        break;
      case 10004:
        productName = 'momang';
        break;
      default:
        productName = sportProducts.getClassName(productId);
    }
    return {
      productId,
      productName
    };
  };
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    loading: true,
    callToActions,
    classes: 'hero-list-image',
    crm,
    dataset: {
      cmsid: bannerId,
      cmstype: contentType,
      impression: true,
      'impression-tracking': trackingString,
      type: layoutType
    },
    features,
    roleDescription: bannerAccessibilityHelpers.ariaRoleDescription(tab, layoutConfig),
    cube: resolveCube(),
    image: images === null || images === void 0 ? void 0 : images.backgroundImage,
    isAdmin,
    isFullWidth,
    slim,
    tab,
    trackingString
  })) || '';
}
if (svs.isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.section_list_image = {
    renderComponent
  };
}

 })(window);